import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { TransferSchool } from '@ascschool/model/transfer/transfer-school-aou.model';
import { TransferSchoolTnService } from '@ascschool/services/transfer/transferschooltn.service';
import { ChuyenNktTiepnhanXulyComponent } from './chuyen-nkt-tiepnhan-xuly/chuyen-nkt-tiepnhan-xuly.component';
import { DistrictService } from '@ascschool/services/category/district.service';
import { TransferSchoolService } from '@ascschool/services/transfer/transferschool.service';
import { ProvinceService } from '@ascschool/services/category/province.service';

@Component({
  selector: 'chuyen-nkt-tiepnhan',
  templateUrl: './chuyen-nkt-tiepnhan.component.html',
  styleUrls: ['./chuyen-nkt-tiepnhan.component.scss']
})
export class ChuyenNktTiepnhanComponent implements OnInit,OnDestroy {
  isResizdePopup: boolean; dialogRef: NzModalRef; titlePopup: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  total: number = 0; firstRowOnPage: any;
  searchAdvanced = false; divisibleForFour: boolean; checkedAll: boolean = false;

  getTypeOfDisabilityACFn: (value: any) => Observable<any>; TypeOfDisabilitySubscription: any; TypeOfDisabilityControl = new FormControl();
  getLevelACFn: (value: any) => Observable<any>; LevelSubscription: any; LevelControl = new FormControl();
  getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; ProvinceControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  getTransferToEatosACFn: (value: any) => Observable<any>; EatosSubscription: any; transferToEatosIdControl = new FormControl();
  listStudent: any; listStudentSelected: number[];
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private modalService: NzModalService, private authQuery: AuthQuery,
    private service: TransferSchoolTnService, public utilService: UtilsService,
    private typeOfDisabilityService: TypeOfDisabilityService, private levelService: LevelService,
    private provinceService: ProvinceService, private districtService: DistrictService,
    private eatosService: TransferSchoolService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }
  get breadcrumbs(): string[] {
    return ['Quản lý người khuyết tật'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  private elementPageHeaderTable: ElementRef;
  $unSubcribe = new Subject();
  currentUser: any;
  buttonTypeEnum = ButtonType; btnType: ButtonType; shortcuts: ShortcutInput[] = []; commonFilter = new CommonFilter();
  searchTerm: string = ''; pageIndex: number = 1; categoryModel = new CategoryModel();
  pageSizeOptions: number[] = [50, 100, 200]; pageSize: number = this.pageSizeOptions[1];
  loading: boolean = true; width: number; numberControl: number; show = false;
  maxHeight: number; height: number; heightPopup: number; heightPagnagation: number = 50; isCollapse = true;
  dateFormat = 'dd/MM/yyyy'; fromDate: any; toDate: any; proFromDate: any; proToDate: any;
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[1];
    this.commonFilter.Gender = -5;
    this.reload();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe(type => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.loadTypeOfDisability();
    this.loadLevel();
    this.loadProvince();
    if (this.isCollapse) {
      this.divisibleForFour = this.isDivisibleForFour(4);
    } else {
      this.divisibleForFour = this.isDivisibleForFour(12);
    }
  }
  reload() {
    this.loading = true;
    this.checkedAll = false;
    this.service.getTransferSchool(this.commonFilter)
    .pipe(takeUntil(this.$unSubcribe)).subscribe((response: any) => {
      this.total = (response && response.rowCount) ? response.rowCount : 0;
      this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
      this.listStudent = response.results ? response.results : [];
      this.loading = false;
      this.listStudent.map(x => x.checked = false);
      this.listStudentSelected = [];
    }, () => {
      this.listStudent = [];
      this.listStudentSelected = [];
      this.loading = false;
    }
    );
  }
  date = null;
  GetFormattedDate(date: any) {
    var month = date.getMonth() + 1; var day = date.getDate(); var year = date.getFullYear();
    return month + "/" + day + "/" + year;
  }
  search() {
    this.updateDate(); this.reload();
  }

  updateDate() {
    this.commonFilter.PageIndex = 1;
    if (this.proFromDate) {
      this.commonFilter.TnFromDate = this.GetFormattedDate(this.proFromDate);
    } else {
      this.commonFilter.TnFromDate = '';
    }

    if (this.proToDate) {
      this.commonFilter.TnToDate = this.GetFormattedDate(this.proToDate);
    } else {
      this.commonFilter.TnToDate = '';
    }

    if (this.fromDate) {
      this.commonFilter.FromDate = this.GetFormattedDate(this.fromDate);
    } else {
      this.commonFilter.FromDate = '';
    }

    if (this.toDate) {
      this.commonFilter.ToDate = this.GetFormattedDate(this.toDate);
    } else {
      this.commonFilter.ToDate = '';
    }
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE; this.pageIndex = pageE; this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE; this.pageSize = pageE; this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse); this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => { this.height = this.heightfnc(); this.width = this.widthfnc(); }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup, this.elementPageSearch, this.elementPageHeaderTable, this.heightPagnagation);
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));

    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() { this.width = this.widthfnc(); this.checkCaculateHeight(this.isCollapse); }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight; this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void {
  }

  popupEdit(data: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Tiếp nhận NKT chuyển cơ sở';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement, nzContent: ChuyenNktTiepnhanXulyComponent,
      nzStyle: { top: '30px' }, nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzComponentParams: { value: data }, nzWidth: 1500
    });
    this.dialogRef.afterClose.subscribe(results => {
      if (results) {
        this.reload();
      }
    });
  }

  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }

  clear() {
    this.commonFilter.TnFromDate = '';
    this.proFromDate = '';
    this.commonFilter.ToDate = '';
    this.proToDate = '';
    this.commonFilter.TnFromDate = '';
    this.fromDate = '';
    this.commonFilter.ToDate = '';
    this.toDate = '';
    this.commonFilter.StudentCode = '';
    this.commonFilter.FullName = '';
    delete this.commonFilter.YearOfBirth;
    delete this.commonFilter.Gender;
    delete this.commonFilter.TransferTypeId;
    this.TypeOfDisabilityControl.setValue(null);
    this.LevelControl.setValue(null);
    this.ProvinceControl.setValue(null);
    this.DistrictControl.setValue(null);
    this.transferToEatosIdControl.setValue(null);
    this.commonFilter.TransferReason = '';
    this.commonFilter.ProcessingNote = '';
    this.reload();
  }
  exportExcel() {
    this.updateDate();
    this.service.export(this.commonFilter).subscribe((data:any) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'XacNhanNktChuyenCoSo.xlsx';
      link.click();
    });
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') { return control.value.id; }
    return '';
  }

  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.ProvinceSubscription) {
      this.ProvinceSubscription = this.ProvinceControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.ProvinceControl.value);
      });
    }
  }
  changeProvince(control: FormControl) {
    this.ProvinceControl = control;
    this.loadDistrict();
    this.DistrictControl.setValue(null);
  }

  loadDistrict() {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.ProvinceControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  changeDistrict(control: FormControl) {
    this.DistrictControl = control;
    this.loadEatos();
    this.transferToEatosIdControl.setValue(null);
  }

  loadEatos() {
    this.getTransferToEatosACFn = (value: any) => this.eatosService.getEatos({
      searchTerm: value, ProvinceId: this.valueIfHas(this.ProvinceControl), DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.EatosSubscription) {
      this.EatosSubscription = this.transferToEatosIdControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TransferEatosId', this.transferToEatosIdControl.value);
      });
    }
  }
  changeEatos(control: FormControl) {
    this.transferToEatosIdControl = control;
  }

  loadTypeOfDisability() {
    this.getTypeOfDisabilityACFn = (value: any) => this.typeOfDisabilityService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfDisabilitySubscription) {
      this.TypeOfDisabilitySubscription = this.TypeOfDisabilityControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'typeOfDisabilityId', this.TypeOfDisabilityControl.value);
      });
    }
  }
  changeTypeOfDisability(control: FormControl) {
    this.TypeOfDisabilityControl = control;
  }

  loadLevel() {
    this.getLevelACFn = (value: any) => this.levelService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.LevelSubscription) {
      this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'levelId', this.LevelControl.value);
      });
    }
  }
  changeLevel(control: FormControl) {
    this.LevelControl = control;
  }

  checked = false;
  indeterminate = false;
  listOfCurrentPageData: TransferSchool[] = [];
  setOfCheckedId = new Set<number>();
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.filter(q => q.tranferType == 1).forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: TransferSchool[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  handlerResizePopup() {
    this.isResizdePopup = !this.isResizdePopup;
    let width = 1500;
    let height = this.caculateHeightPopup(window.innerHeight) + 'px';
    let top = 30;
    if (this.isResizdePopup === true) {
      width = window.innerWidth;
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width, nzStyle: { top: top + 'px' },
      nzBodyStyle: { overflow: 'auto', maxheight: height, height: height }
    });
  }
  ngOnDestroy(): void {
    this.$unSubcribe.next();
    this.$unSubcribe.complete();
}
}
